import { FormFieldLabel } from '../../form/FormFieldLabel'

export const LegacyDisplayField = ({
  label,
  value,
  className,
}: {
  label: string
  value: string | number
  className?: string
}) => (
  <div className={className}>
    <FormFieldLabel
      text={label}
      isLegacy
    />
    <p>{value}</p>
  </div>
)
